import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "calendar text-primary" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between calendar-header" }
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "text-subtitle m-0",
  id: "calendar-month"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "calendar-grid" }
const _hoisted_8 = ["disabled", "data-date", "onClick"]
const _hoisted_9 = {
  key: 1,
  class: "text-paragraph text-primary50 text-center calendar-empty"
}

import { computed, onMounted, ref, watch } from "vue";
import moment from "moment";
import type { CalendarDay, CalendarMonth } from "@/app/formatters/schedule";
import AppCheckRow from "@/components/app/AppCheckRow.vue";
import AppSection from "@/components/app/AppSection.vue";
import { useAvailableTimes } from "@/composables/useSchedule";


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarComponent',
  props: {
    months: { default: () => [] },
    psiId: {},
    allowOnline: { type: Boolean, default: false }
  },
  emits: ["onDateChanged"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const selectedTime = ref("");
const selectedDate = ref<string>("");
const selectedMonthPosition = ref(0);

const currentMonth = computed(() => props.months[selectedMonthPosition.value]);
const currentMonthString = computed(() =>
  `${(currentMonth.value?.date ?? moment(selectedDate.value || undefined)).format("MMMM [de] YYYY")}`.capitalizeFirst().toString(),
);

const { data: timesData, isFetching: loadingTimes } = useAvailableTimes(() => Number(props.psiId) || undefined, selectedDate);
const times = computed(() => (selectedDate.value ? (timesData.value ?? []) : []));

// trocar o dia limpa o horário escolhido (a não ser "online", que vale para qualquer dia)
watch(selectedDate, () => {
  if (selectedTime.value != "online") {
    selectedTime.value = "";
    emit("onDateChanged", "");
  }
});
watch(selectedTime, (t) => emit("onDateChanged", t));

onMounted(() => {
  if (props.allowOnline) selectedTime.value = "online";
  selectedDate.value = props.months[0]?.firstAvailableDay || "";
});

function handleChangeMonth(plus = true) {
  const pos = selectedMonthPosition.value + (plus ? 1 : -1);
  // são 6 meses (buildMonths); nas pontas não faz nada
  if (pos < 0 || pos > props.months.length - 1) return;
  selectedMonthPosition.value = pos;
  selectedDate.value = props.months[pos].firstAvailableDay || "";
}
// "Hoje": volta para o mês atual e marca o dia de hoje (como no app; sem horários, aparece o aviso)
function todayPressed() {
  selectedMonthPosition.value = 0;
  selectedDate.value = moment().format("YYYY-MM-DD");
}
function handleDateSelected(day: CalendarDay) {
  if (!day.disabled || day.isToday) selectedDate.value = day.formattedDate;
}
function dayClass(day: CalendarDay) {
  if (day.formattedDate == selectedDate.value) return "selected";
  if (day.isToday) return "today";
  if (day.disabled) return "disabled";
  return "";
}
function handleTimeSelected(timeAndDate: string) {
  selectedTime.value = timeAndDate;
  emit("onDateChanged", timeAndDate);
}

return (_ctx: any,_cache: any) => {
  const _component_TimezoneAlert = _resolveComponent("TimezoneAlert")!
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "calendar-nav",
          disabled: selectedMonthPosition.value == 0,
          "aria-label": "Mês anterior",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChangeMonth(false)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "fas fa-chevron-circle-left" }, null, -1)
        ]))], 8, _hoisted_4),
        _createElementVNode("p", _hoisted_5, _toDisplayString(currentMonthString.value), 1),
        _createElementVNode("button", {
          type: "button",
          class: "calendar-nav",
          disabled: selectedMonthPosition.value == __props.months.length - 1,
          "aria-label": "Próximo mês",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeMonth(true)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "fas fa-chevron-circle-right" }, null, -1)
        ]))], 8, _hoisted_6)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link p-0 text-subtitle text-secondary text-decoration-none",
        id: "calendar-today",
        onClick: todayPressed
      }, "Hoje")
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (week) => {
        return _createElementVNode("span", {
          key: week,
          class: "text-label calendar-weekday"
        }, _toDisplayString(week), 1)
      }), 64)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMonth.value?.month, (week, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day) => {
            return (_openBlock(), _createElementBlock("button", {
              key: day.formattedDate,
              type: "button",
              class: _normalizeClass(["calendar-day", dayClass(day)]),
              disabled: day.disabled && !day.isToday,
              "data-date": day.formattedDate,
              onClick: ($event: any) => (handleDateSelected(day))
            }, _toDisplayString(Number(day.day)), 11, _hoisted_8))
          }), 128))
        ], 64))
      }), 128))
    ]),
    _createVNode(AppSection, {
      class: "calendar-times",
      title: "Horários disponíveis"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_TimezoneAlert, { class: "order-last" })
      ]),
      default: _withCtx(() => [
        (_unref(loadingTimes))
          ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.allowOnline)
                ? (_openBlock(), _createBlock(AppCheckRow, {
                    key: 0,
                    label: "Agendar para agora!",
                    checked: selectedTime.value == 'online',
                    id: "time-online",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTimeSelected('online')))
                  }, {
                    extra: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "app-badge app-badge-success text-label" }, "Disponível agora", -1)
                    ]))]),
                    _: 1
                  }, 8, ["checked"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(times.value, (time) => {
                return (_openBlock(), _createBlock(AppCheckRow, {
                  key: time.date,
                  label: String(time.formattedDate.capitalizeFirst()),
                  checked: selectedTime.value == time.date,
                  class: "calendar-time",
                  onClick: ($event: any) => (handleTimeSelected(time.date))
                }, null, 8, ["label", "checked", "onClick"]))
              }), 128)),
              (!times.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Nenhum horário disponível"))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})